module.exports = __webpack_public_path__ + "img/pro3.024e3075.png";